
import { createStyles } from "../../lib/helpers"


const styles = createStyles({
 card: {

    
    display: "flex",
    flex: 1,
    flexDirection: "column",
    // alignItems: "center",
    fontSize: "calc(10px + 2vmin)",
    paddingTop: "5vh",
    paddingBottom: "5vh",
    paddingLeft:"4vw",
    paddingRight:"4vw",
    //borderTop: "1px solid var(--git-black-half)",
    
    //  boxShadow: "0px 2px 10px var(--git-black-half)",
    //backdropFilter: "blur(8px)",

    backgroundColor: "rgb(255,252,250)",
    overflowX: "hidden",
    marginLeft:"5vw",
    marginRight:"5vw",
   
    marginBottom:"5vh",
    marginTop:"0vh",
    borderRadius:4,
    border:"1px solid var(--git-black)"



  },

})

export default styles